<template>
	<div class="instagram-feed">
		<div class="post" v-for="post in posts" :key="post.id">
			<div
				class="image"
				:style="{
					backgroundImage: `url(${post.images.standard_resolution.url})`
				}"
			/>
			<div class="tags">
				{{
					post.caption.text.substring(0, 100) +
						(post.caption.length < 100 ? "" : "...")
				}}
				<!-- <span v-for="tag in post.tags.slice(0, 6)" :key="tag">
          #{{ tag }}
        </span> -->
			</div>

			<a class="t-link post-link" target="_blank" :href="post.link">
				<i class="fab fa-instagram"></i>
				View on Instagram
			</a>
		</div>
	</div>
</template>

<script>
const INSTAGRAM_RECENT_ENDPOINT =
	"https://api.instagram.com/v1/users/self/media/recent";

export default {
	name: "InstagramFeed",
	selector: "#vue-instagram-feed",
	props: {
		accessToken: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			posts: []
		};
	},
	async mounted() {
		const { data } = await this.$http(INSTAGRAM_RECENT_ENDPOINT, {
			params: {
				access_token: this.accessToken,
				count: 4
			}
		});
		data.data.forEach(post => post.tags.sort());
		this.posts = data.data;
	}
};
</script>

<style lang="scss" scoped>
.instagram-feed {
	@include grid(4);

	@include media("<=desktop") {
		@include grid(3);
		.post:nth-child(n + 4) {
			display: none;
		}
	}

	@include media("<=desktop") {
		@include grid(2);
		.post:nth-child(n + 3) {
			display: none;
		}
	}
}

.post {
	display: flex;
	flex-direction: column;
}

.image {
	padding-bottom: 100%;
	background-size: cover;
	background-position: center;
}

.tags {
	margin-top: 16px;
	font-family: $font-family-mono;
	font-size: 12px;
	height: 100%;
}

.post-link {
	display: inline-block;
	margin-top: 12px;
	font-size: 12px;
	align-self: flex-start;
}
</style>